import $ from 'jquery'; 
import { importComponent, max767 } from "../utils";
import { componentList } from "../componentList";

const DynamicImports = () => {
  let windowEl;

  // Set DOM references
  const setDomMap = () => {
    windowEl = $(window); // jQuery reference to the window
  };

  // Bind window events (e.g., scroll)
  const bindEvents = () => {
    windowEl.on("scroll", windowScroll);
  };

  // Handle window scroll events
  const windowScroll = () => {
    components(); // Recheck components when scrolling
  };

  // Dynamically import components based on conditions
  const components = () => {
    if (componentList) {
      $.each(componentList, (_, { element: el, functionName: classID, mobile }) => {
        if (!mobile && max767.matches) return; // Skip if not mobile and matches certain criteria
        importComponent(el, classID); // Dynamically import the component
      });
    }
  };

  // Initialize the dynamic imports
  const init = () => {
    setDomMap();     // Set the DOM elements
    bindEvents();    // Bind scroll event to window
    components();    // Initialize components on load
  };

  // Immediately invoke the init function on script execution
  init();
};

export default DynamicImports;
